<template>
  <v-content class="content_body">
    <!-- Grupo de modalidades -->
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <label class="font-weight-black caption"
            >Escolha o Grupo de Modalidades</label
          >
        </v-flex>
        <div class="box-buttons">
          <v-btn
            v-for="(productGroup, index) in productGroups"
            :key="index"
            v-if="productGroup.modalidades.length"
            :id="productGroup.nome.replace(/ /g,'')"
            class="jns-button blue-button flex xs6 mb-4 pull-right"
            :class="{ active: selectedProductGroup == index }"
            :value="index"
            @click="selectProductGroup($event, productGroup.id_grupo)"
          >
            <div class="overflow-ok">
              <p>{{ productGroup.nome }}</p>
              <v-icon v-if="selectedProductGroup == index" class
                >check_circle_alt</v-icon
              >
            </div>
          </v-btn>
        </div>
      </v-layout>
    </v-flex>
    <!-- ./Grupo de modalidades -->

    <!-- Modalidade Principal -->
    <v-flex
      xs12
      v-if="selectedGroupModalidades && selectedGroupModalidades.length"
    >
      <v-layout row wrap>
        <v-flex xs12>
          <label class="font-weight-black caption" for
            >Escolha a modalidade principal</label
          >
        </v-flex>
        <div class="box-buttons">
          <v-btn
            v-for="(modalidade, index) in selectedGroupModalidades"
            :key="index"
            :id="modalidade.nome.replace(/ /g, '')"
            class="jns-button blue-button flex xs4 mb-4 pull-right"
            :class="{ active: selectedProduct === modalidade.id }"
            :value="modalidade.id"
            @click="selectProduct($event)"
          >
            <div class="overflow-ok">
              <p>{{ modalidade.nome }}</p>
              <v-icon v-if="selectedProduct === modalidade.id" class
                >check_circle_alt</v-icon
              >
            </div>
          </v-btn>
        </div>
      </v-layout>
    </v-flex>
    <!-- ./Modalidade Principal -->

    <!-- Modalidade Complementar -->
    <v-flex
      xs12
      v-if="selectedProductGroup && selectedProduct && selectedGroupCoberturas"
    >
      <v-layout row wrap v-if="selectedGroupCoberturas.length > 0">
        <v-flex xs12>
          <label class="font-weight-black caption" for
            >Escolha a Modalidade Complementar</label
          >
        </v-flex>
        <div class="box-buttons">
          <v-btn
            v-for="(cobertura, index) in selectedGroupCoberturas"
            :key="index"
            :id="cobertura.nome.replace(/ /g, '')"
            class="jns-button blue-button flex xs4 mb-4 pull-right"
            :class="{
              active: selectedCoverages.includes(cobertura.id.toString()),
            }"
            :value="cobertura.id"
            @click="toggleCoverage($event)"
          >
            <div class="overflow-ok">
              <p>{{ cobertura.nome }}</p>
              <v-icon
                v-if="selectedCoverages.includes(cobertura.id.toString())"
                class
                >check_circle_alt</v-icon
              >
            </div>
          </v-btn>
        </div>
      </v-layout>
    </v-flex>
    <!-- ./Modalidade Complementar -->

    <!-- Coberturas adicionais -->
    <v-flex
      xs12
      v-if="
        selectedProductGroup &&
          selectedProduct &&
          selectedGroupCoberturasAdicionais.length
      "
    >
      <v-layout row wrap>
        <v-flex xs12>
          <label class="font-weight-black caption" for
            >Escolha as Coberturas Adicionais</label
          >
        </v-flex>
        <div class="box-buttons">
          <v-btn
            v-for="(
              coberturaAdicional, index
            ) in selectedGroupCoberturasAdicionais"
            :key="index"
            :id="coberturaAdicional.nome.replace(/ /g, '-')"
            class="jns-button blue-button flex xs4 mb-4 pull-right"
            :class="{
              active: selectedAdditionalCoverages.includes(
                coberturaAdicional.id.toString()
              ),
            }"
            :value="coberturaAdicional.id"
            @click="toggleAdditionalCoverage($event)"
          >
            <div class="overflow-ok">
              <p>{{ coberturaAdicional.nome }}</p>
              <v-icon
                v-if="
                  selectedAdditionalCoverages.includes(
                    coberturaAdicional.id.toString()
                  )
                "
                class
                >check_circle_alt</v-icon
              >
            </div>
          </v-btn>
        </div>
      </v-layout>
    </v-flex>

    <div class="msg_warn" v-if="showWarn">
      <p>
        Conforme Art. 2º do Ato Conjunto n°1 de 16 de Outubro de 2019, o
        Segurado das apólices de Seguro Garantia de Depósito Recursal deve ser o
        reclamante ou o exequente e não mais a Vara ou Tribunal.
      </p>
    </div>

    <!-- ./Coberturas adicionais -->
  </v-content>
</template>
<script lang="js">
export default {
  name: "ModalidadePasso3",
  data: () => ({
    showWarn: true,
  }),
  props: [
    "step",
    "productGroups",
    "selectedProductGroup",
    "selectedGroupModalidades",
    "selectedProduct",
    "selectedGroupCoberturas",
    "selectedCoverages",
    "selectedGroupCoberturasAdicionais",
    "selectedAdditionalCoverages",
  ],
  methods: {
    selectProductGroup($event, id_grupo) {
      this.$emit("selectProductGroup", event, id_grupo);
    },
    selectProduct($event) {
      this.$emit("selectProduct", event);
    },
    toggleCoverage($event) {
      this.$emit("toggleCoverage", event);
    },
    toggleAdditionalCoverage(event) {
      this.$emit("toggleAdditionalCoverage", event);
    },
    sortedArray(array) {
      function compare(a, b) {
        if (a.nome < b.nome) return -1;
        if (a.namnomee > b.nome) return 1;
        return 0;
      }
      return array.sort(compare);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss">
#jns {
  .content_body {
    padding: 20px 40px 77px 40px !important;
    background-color: white;
  }

  .msg_warn {
    width: 58%;
    background-color: #ccc;
    position: fixed;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    border-radius: 0.4em;
    left: 20%;
    bottom: 20px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .box-buttons {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .jns-button {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40%;
      width: 45%;
      max-width: 100%;

      .overflow-ok {
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
        overflow: hidden !important;

        p {
          white-space: nowrap !important;
          text-overflow: ellipsis !important;
          overflow: hidden !important;
          margin: 0;
        }
      }
    }
  }

  @media screen and (max-width: 1045px) {
    .box-buttons {
      .jns-button {
        font-size: 1rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .msg_warn {
      width: 100%;
      left: 2px;
      right: 2px;
      bottom: 60px;
      padding: 6px;

      p {
        font-size: 0.800rem !important;
        text-align: justify;
      }
    }

    .box-buttons {
      flex-direction: column;

      .jns-button {
        width: 100% !important;
        overflow: none;
        font-size: 0.875rem;
      }
    }
  }

  @media screen and (max-width: 400px) {
    .box-buttons {
      .jns-button {
        width: 100% !important;
        overflow: visible;
        font-size: 0.725rem;

        .overflow-ok {
          white-space: pre-line !important;
          text-overflow: initial !important;
          overflow: visible !important;

          p {
            text-align: center;
            display: block;
            white-space: pre-line !important;
            text-overflow: initial !important;
            line-height: 1.5em;
            overflow: visible !important;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Propostas/Passos/Modalidade.vue